<script>
    import DataTable from "../../components/data-table.svelte";

    let users=[
        {id:1,roleId:"S",firstName:"John",middleName:"",lastName:"Smith",email:"john.smith@mail.co.uk",dob:"2 May 1995",role:"Staff",year:"-",class:"Support Team"},
        {id:1,roleId:"S",firstName:"John",middleName:"",lastName:"Smith",email:"john.smith@mail.co.uk",dob:"2 May 1995",role:"Staff/Engineer",year:"-",class:""},
        {id:1,roleId:"S",firstName:"John",middleName:"",lastName:"Smith",email:"john.smith@mail.co.uk",dob:"2 May 1995",role:"Staff/Contact/Engineer",year:"-",class:"Sales Team"},
        {id:1,roleId:"S",firstName:"John",middleName:"",lastName:"Smith",email:"john.smith@mail.co.uk",dob:"2 May 1995",role:"Staff",year:"-",class:"Sales Team"},
        {id:1,roleId:"S",firstName:"John",middleName:"",lastName:"Smith",email:"john.smith@mail.co.uk",dob:"2 May 1995",role:"Staff/Engineer",year:"-",class:"Engineering"},
        {id:1,roleId:"P",firstName:"John",middleName:"",lastName:"Smith",email:"john.smith@mail.co.uk",dob:"2 May 1995",role:"Pupil",year:"N2",class:"Hazel"},
        {id:1,roleId:"P",firstName:"John",middleName:"",lastName:"Smith",email:"john.smith@mail.co.uk",dob:"2 May 1995",role:"Pupil",year:"R",class:"Cherry"},
        {id:1,roleId:"P",firstName:"John",middleName:"",lastName:"Smith",email:"john.smith@mail.co.uk",dob:"2 May 1995",role:"Pupil",year:"5",class:"Oak"}
    ];

    let DOBcolumnDefs = [{ type: 'date-euro', targets: [3] }];
    let MatchesColumnDefs = [{ type: 'date-euro', targets: [2] }];
</script>

<style>
    .card-title{
        background-color: #136f63; 
        color: white; 
        padding:0.5rem 0.5rem 0 0.5rem;
    }
    .card-title .material-icons.md1::before { 
        content: "keyboard_arrow_up"; 
    }
    .card-title.collapsed .material-icons.md1::before { 
        content: "keyboard_arrow_down"; 
    }
    .btn{
        color: #2e817d;
        border: 1px solid #2e817d;
    }
</style>



<ul class="nav nav-tabs">
    <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#changes">Changes</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#matches">Matches</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#errors">Errors</a>
    </li>
</ul>

<br />

<div class="tab-content">

    <div class="tab-pane active" id="changes">
        <div class="card">

            <!-- <a class="card-title d-block" data-toggle="collapse" href="#mod" aria-expanded="true" aria-controls="mod">
                <h4 style="float: left;">Changes </h4>
                <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
            </a> -->
            
            <div id="mod" class="card-body with-table">
                <DataTable DataLength={users.length} ResponsiveHeader='0,1'>
                    <thead>
                        <tr>
                            <th scope="col" class="sorting_asc" aria-sort="ascending">First Name</th>
                            <th>Last Name</th>                                 
                            <th>Changed field </th>
                            <th>Old value</th>
                            <th>New value </th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each users as user}
                        <tr>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td> Field that was modified </td>
                            <td> abc </td>
                            <td> abd </td>
                        </tr>
                        {/each}
                    </tbody>
                </DataTable>
            </div>
        </div>
    </div>

    <div class="tab-pane" id="errors">
        <div class="card">
            <a class="card-title d-block" data-toggle="collapse" href="#type1" aria-expanded="true" aria-controls="type1">
                <h5 style="float: left;">Invalid names </h5>
                <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
            </a>
            
            <div id="type1" class="collapse card-body with-table">
                <DataTable DataLength={users.length} ResponsiveHeader='0,2'>
                    <thead>
                        <tr>
                            <th scope="col" class="sorting_asc" aria-sort="ascending">First Name</th>
                            <th>Middle Name</th>
                            <th>Last Name</th>                                 
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each users as user}
                        <tr>
                            <td>{user.firstName}</td>
                            <td>{user.middleName}</td>
                            <td>{user.lastName}</td>
                            <td>Reason for error.</td>
                        </tr>
                        {/each}
                    </tbody>
                </DataTable>
            </div>
        </div>

        <br />

        <div class="card">
            <a class="card-title d-block" data-toggle="collapse" href="#type2" aria-expanded="true" aria-controls="type2">
                <h5 style="float: left;">Invalid DoB </h5>
                <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
            </a>
            
            <div id="type2" class="collapse card-body with-table">
                <DataTable DataLength={users.length} columnDefs={DOBcolumnDefs} ResponsiveHeader='0,2'>
                    <thead>
                        <tr>
                            <th scope="col" class="sorting_asc" aria-sort="ascending">First Name</th>
                            <th>Middle Name</th>
                            <th>Last Name</th>                                 
                            <th>Date of Birth</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each users as user}
                        <tr>
                            <td>{user.firstName}</td>
                            <td>{user.middleName}</td>
                            <td>{user.lastName}</td>
                            <td>{user.dob}</td>
                        </tr>
                        {/each}
                    </tbody>
                </DataTable>
            </div>
        </div>
    </div>

    <div class="tab-pane" id="matches">
        <div class="card">
            
            <div id="additions" class="card-body with-table">
                
                <DataTable DataLength={users.length} columnDefs={MatchesColumnDefs} ResponsiveHeader='0,1'>
                    <thead>
                        <tr>
                            <th scope="col" class="sorting_asc" aria-sort="ascending">First Name</th>
                            <th>Last Name</th>                                 
                            <th>Date of Birth</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each users as user}
                        <tr>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>{user.dob}</td>
                            <td><button class="btn">Match</button> </td>
                        </tr>
                        {/each}
                    </tbody>
                </DataTable>
            </div>
        </div>
    </div>
</div>
